/* eslint-disable no-unused-vars */

import { getDataPoints } from '@pages/settings/helper';
import { setDefaultValuesOnAddOrEditEquipmentForm } from './helper';

const getEquipmentTypeVersion = ({
  equipmentCategoryMap,
  equipmentDetails,
  equipmentIdThatAttachedToPSV
}) => {
  const isVesselVersion = equipmentCategoryMap[equipmentDetails?.equipmentCategory]
    ?.allowedForPVCreation
    ? true
    : false;

  const isPSVVersion = equipmentIdThatAttachedToPSV
    ? true
    : equipmentCategoryMap[equipmentDetails?.equipmentCategory]?.allowedForPSVCreation
    ? true
    : false;

  return { isVesselVersion, isPSVVersion };
};

const getEquipmentPSVsInfo = ({
  equipmentId,
  equipmentsMap,
  cacheEquipments,
  psv,
  picklistsMap,
  jurisdictionNumbersMap,
  siteIdForNewEquipment,
  settings
}) => {
  if (siteIdForNewEquipment) {
    return [];
  } else {
    const psvs = psv
      .filter((id) => cacheEquipments?.[equipmentsMap[equipmentId]])
      ?.map((x) => cacheEquipments?.[equipmentsMap[x]]);

    let moreInfoOfPSVs = [];

    for (let eq of psvs) {
      if (eq?.equipmentId) {
        const psvEquipmentData = setDefaultValuesOnAddOrEditEquipmentForm({
          equipmentDetails: eq,
          jurisdictionNumbersMap,
          picklistsMap,
          isPSVs: true,
          pvId: equipmentId
        });

        const equipmentDisplayFields = settings.settings?.['equipmentDisplayFields'] || '';
        const { jurisdictionNumber } = jurisdictionNumbersMap[eq.equipmentId] || {};

        const dataPoints = getDataPoints(
          { ...eq, subtype: eq?.equipmentSubType, jurisdictionNumber },
          equipmentDisplayFields,
          'equipment',
          picklistsMap
        );

        moreInfoOfPSVs.push({ ...psvEquipmentData, dataPoints });
      }
    }
    return moreInfoOfPSVs;
  }
};

const getEquipmentVesselsInfo = ({
  equipmentId,
  equipmentsMap,
  cacheEquipments,
  pv,
  picklistsMap,
  jurisdictionNumbersMap,
  siteIdForNewEquipment,
  pvIds = [],
  vesselEquipmentId
}) => {
  if (siteIdForNewEquipment) {
    return [];
  } else if (vesselEquipmentId) {
    console.log({ vesselEquipmentId });

    const vessel = cacheEquipments?.[equipmentsMap?.[vesselEquipmentId]] || null;

    const category = picklistsMap[vessel?.equipmentCategory]?.value || null;
    const type = picklistsMap[vessel?.equipmentType]?.value || null;

    const obj = vessel?.equipmentEditingStatus
      ? {
          id: vessel?.equipmentId,
          title: `${category} - ${type}`,
          name: vessel?.name || null,
          serial: vessel?.serialNumber || null,
          link: `/equipment-details/${vessel?.equipmentId}`,
          equipmentEditingStatus: vessel?.equipmentEditingStatus || ''
        }
      : null;

    return { moreInfoOfVessel: obj ? [{ ...obj }] : [], attachAndDeAttach: [] };
  } else {
    const pvs = pv
      .filter((id) => cacheEquipments?.[equipmentsMap?.[equipmentId]])
      .map((x) => cacheEquipments[equipmentsMap[x]]);

    const psvsIdsMap =
      pvIds?.reduce((acc, curr) => {
        acc[curr.pvId] = curr.verificationStatus;
        return acc;
      }, {}) || {};

    const moreInfoOfVessel = [];
    const attachAndDeAttach = [];
    pvs?.length > 0
      ? pvs?.map((a) => {
          if (a) {
            const findDeAttachEquipment =
              a.equipmentId && psvsIdsMap[a.equipmentId] === 'detached' ? false : true;

            const category = picklistsMap[a?.equipmentCategory]?.value || null;
            const type = picklistsMap[a?.equipmentType]?.value || null;
            const obj = {
              id: a?.equipmentId,
              title: `${category} - ${type}`,
              name: a?.name || null,
              serial: a?.serialNumber || null,
              link: `/equipment-details/${a?.equipmentId}`,
              equipmentEditingStatus: a?.equipmentEditingStatus || ''
            };
            if (findDeAttachEquipment) {
              obj?.equipmentEditingStatus && moreInfoOfVessel.push(obj);
              attachAndDeAttach.push({
                ...obj,
                verificationStatus: 'attached to'
              });
            } else {
              attachAndDeAttach.push({
                ...obj,
                verificationStatus: 'detached from'
              });
            }
          }
        })
      : [];

    return { moreInfoOfVessel, attachAndDeAttach };
  }
};

export { getEquipmentTypeVersion, getEquipmentPSVsInfo, getEquipmentVesselsInfo };
